import React from "react";
import ActionButton from "./ActionButton";
import { URL } from "../../config";

const ActionButtons = ({ configureUrl }) => {
  const handleBookTestRide = () => {
    const testRideUrl = URL.TEST_RIDE;
    if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.openLinkInBrowser
    ) {
      window.webkit.messageHandlers.openLinkInBrowser.postMessage(testRideUrl);
      console.info(
        "Opened 'Book a Test Ride' in browser via iOS bridge function"
      );
    } else if (
      window.Android &&
      typeof window.Android.openLinkInBrowser === "function"
    ) {
      window.Android.openLinkInBrowser(testRideUrl);
      console.info(
        "Opened 'Book a Test Ride' in browser via Android bridge function"
      );
    } else {
      console.warn(
        "Bridge function not available, opening in a new tab as fallback"
      );
      window.open(testRideUrl);
    }
  };

  const handleConfigureNow = () => {
    window.passURLtoMobile(6.02, configureUrl, "CONFIGURE_NOW");
  };

  return (
    <div className="flex flex-row justify-center gap-4 w-full max-w-md mx-auto px-4">
      <ActionButton onClick={handleConfigureNow}>
        CONFIGURE NOW
      </ActionButton>
      <ActionButton onClick={handleBookTestRide}>
        BOOK A TEST RIDE
      </ActionButton>
    </div>
  );
};

export default ActionButtons;